import { render, staticRenderFns } from "./simple-info.vue?vue&type=template&id=527edda6&scoped=true"
import script from "./simple-info.vue?vue&type=script&lang=js"
export * from "./simple-info.vue?vue&type=script&lang=js"
import style0 from "./simple-info.vue?vue&type=style&index=0&id=527edda6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527edda6",
  null
  
)

export default component.exports